import { render, staticRenderFns } from "./Sugestoes.vue?vue&type=template&id=b67583c8"
import script from "./Sugestoes.vue?vue&type=script&lang=js"
export * from "./Sugestoes.vue?vue&type=script&lang=js"
import style0 from "./Sugestoes.vue?vue&type=style&index=0&id=b67583c8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports